const subdomain = require('./subdomain')
const get = () => JSON.parse(localStorage.getItem(`${subdomain}.openpanes`)) ?? {
  Class: true,
  Category: true,
  Location: true,
  Items: true
}

const set = (key, value) => {
  const openpages = get()
  openpages[key] = value;
  localStorage.setItem(`${subdomain}.openpanes`, JSON.stringify(openpages))
}

module.exports = function(hub, scene, localstore) {
  localstore.use('openpanes', function(params, cb) {
    return cb(null, get('openpanes'));
  });
  hub.every('expand pane {pane}', (p, cb) => {
    set(p.pane, true);
    scene.refreshQueries(['openpanes']);
    scene.update();
    return cb();
  });
  return hub.every('collapse pane {pane}', (p, cb) => {
    set(p.pane, false);
    scene.refreshQueries(['openpanes']);
    scene.update();
    return cb();
  });
};
